module.exports = __webpack_public_path__ + "img/noir.1582f505.svg";